import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=765b7401&"
import script from "./TheMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports